import { BasketsComparator } from './basket-handling';

/**
 *  Instantiate listener on retailer and Miam
 */
export class BasketHandler  {

  _firstMiamBasketReceived; // we use a behaviourSubject and first emit value is not relevant
  _comparatorClass; // class use for _compartor
  _comparator;
  _basketWrapper;

  /**
   * @param {*} basketsComparatorClass default is BasketsComparator you can override this
   * class to provide custom behaviours
   */
  constructor(basketWrapper, confirmationUrl = null, basketsComparatorClass = BasketsComparator){
    this._basketWrapper = basketWrapper;
    this._comparatorClass = basketsComparatorClass;
    this._firstMiamBasketReceived = false;
    this.initBasketProcess(confirmationUrl);
  }

  initBasketProcess(confirmationUrl) {
    this.handlePayment(() => {
      this.handleBasketSync();
    });
    if(confirmationUrl) {
      this.listenForConfirmation(confirmationUrl);
    }
  }

  listenForConfirmation(confirmationUrl) {
    const basketHandler = this; // neeed the ref as 'this' changes in the MutationObserver
    // initial check if we directly go on page or page reload
    var previousUrl = basketHandler.checkAndSendEvent(undefined, confirmationUrl);
    var observer = new MutationObserver(function() {
      previousUrl = basketHandler.checkAndSendEvent(previousUrl, confirmationUrl);
    });
    observer.observe(document.body, { attributes: false, childList: true, subtree: false })
  }

  checkAndSendEvent(previousUrl, confirmationUrl) {
    if (location.href !== previousUrl) {
      previousUrl = location.href;
      if(location.href.includes(confirmationUrl)) {
        const total = this._basketWrapper.paymentTotal();
        window.mealz.paymentStarted(total);
      }
    }
    return location.href;
  }

  /**
   * 
   * @param {*} callback 
   */
  handlePayment(callback) {
    if (this._basketWrapper.hasPayment()) {
      const total =  this._basketWrapper.paymentTotal();
      const token = localStorage.getItem('_miam/basketToken');
      if (token) {
        // Miam basket that was confirmed on miam.tech => validate payment
        localStorage.removeItem('_miam/basketToken');
        this.sendMiamOrder(total, token);
        callback();
      } else {
        // Local Miam basket (with entries OR NOT) => confirm it and validate payment only if total received from miam > 0
        this.confirmBasket(total, callback);
      }
    } else {
      callback();
    }
  }

  /**
   * 
   * @param {*} total 
   * @param {*} token 
   */
   sendMiamOrder(total, token) {
    if (token) {
      // console.log('[Miam] Send payment notification', token);
      window.mealz.supplier.notifyBasketUpdated(token, 'PAID', total);
    }
  }

  /**
   * 
   * @param {*} total 
   * @param {*} callback 
   */
  confirmBasket(total, callback) {
    window.mealz.basket.confirm(total).subscribe(basket => {
      if (basket && basket.token && basket.totalPrice > 0) {
        // console.debug('[Miam] payment detected', total, token);
        
        const token = basket.token;
        // console.log('[Miam] Send confirmation notification', token);
        window.mealz.supplier.notifyBasketUpdated(token, 'CONFIRMED');
        this.sendMiamOrder(total, token);
      }
      callback();
    });
  }

  /**
   * To implement for each retailer
   */
  listenToRetailer(callback) {
    this._basketWrapper.listenToRetailerBasket(callback); 
  }

  /**
   * need to be call with bind(this) to keep object ref
   * else this 'll be globale 'this' => window
   * @param {*} callback 
   */
  listenToMiam(callback) {
    window.mealz.basket.entries$.subscribe(miamBasket => {
      //  console.debug('Miam basket received', miamBasket, this._firstMiamBasketReceived);
      if (!this._firstMiamBasketReceived && miamBasket.length === 0) {
        // Skip first empty array received
        this._firstMiamBasketReceived = true;
        return;
      } else {
        callback(miamBasket);
      }
    });
  }

  /**
   * 
   */
  handleBasketSync() {
    this.listenToMiam(miamBasket => {
      // Comparison should be initialized when first Miam basket is received, based on existing Retailer basket
      if (!this._comparator) {
        const existingRetailerBasket =  this._basketWrapper.getBasketProducts();
        this._comparator = new this._comparatorClass( this._basketWrapper, existingRetailerBasket, miamBasket);
        // We listen to Retailer basket updates only after the first basket is received from Miam
        this.listenToRetailer(this.retailerBasketChangeCallBack.bind(this));
        return;
      }
      if (this._comparator.isProcessingRetailerEvent) {
        // console.debug('skipping retailer is processing');
        return;
      }
      // When comparison is already initialized, we just update it
      this._comparator.updateReceivedFromMiam(miamBasket)
    });
  }

  /**
   * 
   * @param {*} retailerBasket 
   */
  retailerBasketChangeCallBack(retailerBasket){
    this._comparator.updateReceivedFromRetailer(retailerBasket)
  }

}